import component from '@/mixins/component'

import Draggable from 'gsap/Draggable'
import '@/js/greensock/plugins/ThrowPropsPlugin'

export default {
  name: 'push-partner',
  mixins: [component],
  data () {
    return {
      needIntersection: true,
      currentIndex: 0,
      snaps: [],
      nbVisible: 0
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  mounted () {
    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)

    if (this.$refs['slider-container'].getBoundingClientRect().width < window.innerWidth) {
      this.$refs['arrows'].style.display = 'none'
    } else {
      this.initDrag()
    }
  },
  methods: {
    show () {
      // this.$el.classList.remove('hidden')
    },
    hide () {
      // this.$el.classList.add('hidden')
    },
    initDrag () {
      const screenWidth = window.innerWidth
      this.snaps = this.$refs['slider-item'].map(item => {
        const boundings = item.$el.getBoundingClientRect()
        return -(boundings.left + boundings.width - screenWidth)
      })
      console.log(this.snaps)
      this.nbVisible = Math.floor(screenWidth / this.$refs['slider-item'][0].$el.offsetWidth)
      this.slider = new Draggable(this.$refs['slider-container'], {
        type: 'x',
        edgeResistance: 0.9,
        throwProps: true,
        zIndexBoost: false,
        bounds: {
          minX: 0,
          maxX: this.snaps[this.snaps.length]
        },
        snap: {
          x: this.snaps
        },
        onRelease: () => {
          if (this.slider.endX !== this.slider.currentEndX) {
            this.dragEndHandler(this.slider.endX)
          }
        }
      })
    },
    dragEndHandler (x) {
      if (isNaN(x)) return
      x = x || 0
      this.currentIndex = this.snaps.indexOf(x)
    },
    prev () {
      this.currentIndex--
      this.go(this.currentIndex)
    },
    next () {
      this.currentIndex++
      this.go(this.currentIndex)
    },
    go (index) {
      TweenMax.to(this.$refs['slider-container'], 0.3, { x: this.snaps[index] })
    }
  }
}
